import { render, staticRenderFns } from "./remove_pending.vue?vue&type=template&id=6b82cf88&scoped=true&"
import script from "./remove_pending.vue?vue&type=script&lang=js&"
export * from "./remove_pending.vue?vue&type=script&lang=js&"
import style0 from "./remove_pending.vue?vue&type=style&index=0&id=6b82cf88&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b82cf88",
  null
  
)

export default component.exports